import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Autocomplete, Box, Button} from 'views/components';

import {DatePicker} from 'views/module';

import {translate} from 'views/module';

import momentTZ from 'moment-timezone';

const daysOfWeek = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

const LiveInDate = (props) => {
  const newEvent = props.newEvent;
  const updateLiveIn = props.updateLiveInData;
  const setIsStepValid = props.setIsStepValid;
  const liveInData = newEvent.liveInData || {};
  const startDate = liveInData.startDate || momentTZ();
  const endDate = liveInData.endDate || null;
  const byweekday = liveInData.byweekday || [];
  const timezone = liveInData.timezone || null;

  // Sets default value
  React.useEffect(() => {
    if (!newEvent.liveInData) {
      updateLiveIn((prev) => ({
        startDate: momentTZ(),
        byweekday: daysOfWeek,
        timezone: momentTZ.tz.guess(),
      }));
    } else if (!newEvent.liveInData.startDate) {
      updateLiveIn((prev) => ({
        ...prev,
        startDate: momentTZ(),
      }));
    }
  }, [newEvent.liveInData, updateLiveIn]);

  const handleLiveInChange = (e) => {
    const {name, value} = e;
    updateLiveIn((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleDaySelection = (day) => {
    updateLiveIn((prev) => {
      const {byweekday} = prev;
      return {
        ...prev,
        byweekday: byweekday.includes(day) ?
            byweekday.filter((d) => d !== day) : // Remove if already selected
            [...byweekday, day], // Add if not selected
      };
    });
  };

  const makeTimezonesList = React.useCallback(() => {
    const timezones = momentTZ.tz.names();
    const formatted = timezones.map((timezone) => {
      return {
        group: translate('client.ClientDetail.Scheduling.Timezone.Timezones'),
        value: timezone,
        label: timezone,
      };
    });
    return [...formatted];
  }, []);

  // Sets validation
  React.useEffect(() => {
    const isGenerallyValid = startDate && timezone;
    if (!isGenerallyValid) {
      setIsStepValid(false);
      return;
    }
    if (!byweekday.length) {
      setIsStepValid(false);
      return;
    }

    setIsStepValid(true);
  }, [liveInData]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <DatePicker
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.StartDate')}
          value={startDate}
          onChange={(date) => handleLiveInChange({name: 'startDate', value: date})}
          textFieldProps={{
            fullWidth: true,
            InputLabelProps: {shrink: true},
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.EndDateDisplay')}
          value={endDate}
          onChange={(date) => handleLiveInChange({name: 'endDate', value: date})}
          textFieldProps={{
            fullWidth: true,
            InputLabelProps: {shrink: true},
          }}
        />
      </Grid>
      {/* Additional fields for WEEKLY, MONTHLY, YEARLY recurrence (optional based on freq) */}
      <Grid item xs={12}>
        <Box display="flex">
          {
            daysOfWeek.map((day) => (
              <Button
                key={day}
                variant={byweekday.includes(day) ? 'contained' : 'outlined'}
                onClick={() => toggleDaySelection(day)}
                sx={{
                  minWidth: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  fontSize: '16px',
                  padding: '0',
                  mr: 1,
                }}
              >
                {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.DayOfTheWeek.${day}`)}
              </Button>
            ))
          }
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={makeTimezonesList()}
          value={timezone || momentTZ.tz.guess()}
          label={translate('client.ClientDetail.Scheduling.Timezone.Timezones')}
          onChange={(data) => handleLiveInChange({name: 'timezone', value: data.value})}
          sx={{minWidth: {xs: '192px', md: '256px'}}}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            );
          }}
          groupBy={(dropdownItem) => dropdownItem.group}
          isOptionEqualToValue={(option, value) => option.value === value}
          disableClearable
        />
      </Grid>
    </Grid>
  );
};

LiveInDate.propTypes = {
  eventType: PropTypes.oneOf(['RECURRENCE_EVENT', 'FIXED_EVENT', 'LIVEIN_EVENT']),
  setEventType: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  newEvent: PropTypes.object.isRequired,
  updateEventData: PropTypes.func.isRequired,
  updateRecurrenceData: PropTypes.func.isRequired,
  updateLiveInData: PropTypes.func.isRequired,
  updateBreakDetails: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(LiveInDate));
